import en from "./en.ftl";
import ar from "./ar.ftl";
import fr from "./fr.ftl";
import de from "./de.ftl";
import es from "./es.ftl";
import {SupportedLanguage} from "i18n/constants";

const locales: Record<SupportedLanguage, string> = {en, ar, fr, de, es};

export default locales;
